// Returns action creators for each lookup action type
import { SET_LOOKUPS } from "../actionTypes";

// Action creators for filter panel lookups slice
export const setLookups = (lookups) => {
    return { type: SET_LOOKUPS, payload: lookups };
};
